import React, { useState, useEffect } from "react";
import Container from "@mui/material/Container";
import CheckIcon from "@mui/icons-material/Check";
import { useParams } from "react-router-dom";
import LinearProgress from "@mui/material/LinearProgress";
import { validarSuscriptor } from "../Services/suscriptorServices";
import { NoBackpackSharp } from "@mui/icons-material";

const Validar = (props) => {
  const [status, setStatus] = useState(null);

  const { valcode } = useParams();

  useEffect(() => {
    //console.log(valcode);
    validar();
  }, []);

  const validar = async () => {
    const { data: ret } = await validarSuscriptor(valcode);
    setStatus(ret === 1 ? 1 : 0);
  };

  return (
    <Container>
      <h3 style={{ textAlign: "center" }}>ESTAMOS VALIDANDO TU EMAIL</h3>
      <p>
        {status === null && <LinearProgress />}
        {status === 1 && (
          <>
            <CheckIcon sx={{ fontSize: 40 }}></CheckIcon> &nbsp;Tu cuenta ha
            sido activada. Muchas gracias por suscribirte.
          </>
        )}
        {status === 0 && "Ha ocurrido un error al validar tu email."}
      </p>
    </Container>
  );
};

export default Validar;
